import { useT } from "@transifex/react";
import { ReactComponent as SVG404 } from "../../../assets/img/404.svg";
import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";

const OnlineTestError = () => {
    const t = useT();
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const t_siteNotFound = t("Ups, the site was not found!", { _tags: "errorScreen" });
    const t_askTeacher = t("Please ask your teacher, if she can help you.", { _tags: "errorScreen" });

    return (
        <div
            className="relative w-full h-full"
            data-testid="online-test-error"
        >
            <div
                className={`absolute z-10 max-w-[45%] ${getStyleBasedOnBreakpoint(
                    Breakpoint.LG,
                    "left-[15%] top-[20%]",
                    "relative left-auto top-auto max-w-full flex-1 text-center p-m"
                )}`}
            >
                <p className="text-[6rem]">{"404"}</p>
                <p className="text-[2rem]">{t_siteNotFound}</p>
                <p className="text-[2rem]">{t_askTeacher}</p>
            </div>
            <div className={`h-full ${getStyleBasedOnBreakpoint(Breakpoint.LG, "w-[60%] mx-auto", "w-full")}`}>
                <SVG404 />
            </div>
        </div>
    );
};

export default OnlineTestError;
